import { CardAddFormFieldNamesEnum } from './cardAddFormFieldNamesEnum'

export const CREDIT_CARD_FIELDS_REQUIRED_FOR_SUBMISSION = [
  CardAddFormFieldNamesEnum.FirstName,
  CardAddFormFieldNamesEnum.LastName,
  CardAddFormFieldNamesEnum.City,
  CardAddFormFieldNamesEnum.PostalCode,
  CardAddFormFieldNamesEnum.State,
  CardAddFormFieldNamesEnum.StreetAddressOne,
  CardAddFormFieldNamesEnum.CountryCode
]

export const ACH_FIELDS_REQUIRED_FOR_SUBMISSION = [
  CardAddFormFieldNamesEnum.BankAccountNumber,
  CardAddFormFieldNamesEnum.RoutingNumber,
  CardAddFormFieldNamesEnum.BankAccountType,
  CardAddFormFieldNamesEnum.AgreementIndicator
]

export function fieldsRequiredForCardSubmission (isAchSection: boolean): CardAddFormFieldNamesEnum[] {
  if (isAchSection) {
    return ACH_FIELDS_REQUIRED_FOR_SUBMISSION
  }
  return CREDIT_CARD_FIELDS_REQUIRED_FOR_SUBMISSION
}

export const validators: { [key in CardAddFormFieldNamesEnum]?: (arg0: string) => string | null } = {
  [CardAddFormFieldNamesEnum.FirstName]: val => {
    if (!val) { return 'First Name is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.LastName]: val => {
    if (!val) { return 'Last Name is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.BankAccountType]: val => {
    if (!val) { return 'Account Type is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.RoutingNumber]: val => {
    if (!val) { return 'Routing Number is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.BankAccountNumber]: val => {
    if (!val) { return 'Account Number is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.AgreementIndicator]: val => {
    if (!val) { return 'Agreement is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.StreetAddressOne]: val => {
    if (!val) { return 'Address is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.City]: val => {
    if (!val) { return 'City is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.State]: val => {
    if (!val) { return 'State is Required' }
    return null
  },
  [CardAddFormFieldNamesEnum.PostalCode]: val => {
    if (!val) { return 'Postal Code is Required' }
    if (val.length !== 5) { return 'Must be 5 digits' }
    return null
  }
}
